import styled from 'styled-components';

type Props = {
  hasMediaGroup: boolean;
};

const AdvertiserCampaignSelectorStyled = styled.div<Props>`
  .advertiserCampaignSelector {

    &__title {
      color: var(--color-sonata-primary-700, #283D60);
      font: var(--font-body-400-bold);
      margin-bottom: var(--spacing-16);
    }

    &__groupAgencyContainer, &__advertiserContainer {
      display: flex;
      flex-wrap: nowrap;
      justify-content: center;
      gap: 16px;
    }

    &__advertiserContainer {
      margin-top: 16px;
    }
    
    &__groupAgencyContainer {
      padding-right: ${props => (props.hasMediaGroup ? 0 : '16px')};
      justify-content: start;
    }

    &__agencySelector {
      flex: ${props => (props.hasMediaGroup ? 1 : 0.5)};
    }
    
    &__groupSelector, &__advertiserSelector, &__advertiserUrlContainer {
      flex: 1;
    }
    &__advertiserUrlContainer {
      align-self: flex-end;
    }
    &__advertiserUrlInput {
      height: 39px;
      width: 100%;
    }
    &__advertiserNameLabel, &__advertiserUrlLabel {
      margin-bottom: 5px;
      color: ${props => props.theme.textColorDark};
      font-family: ${props => props.theme.fontRegular};
      font-size: ${props => props.theme.fontSizeS};
    }
  }
`;

export { AdvertiserCampaignSelectorStyled };
